import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";

import { FuseSharedModule } from "@fuse/shared.module";

import { AsapMaterialModule } from "../../../../material-module";
import { NgxDaterangepickerMd } from "ngx-daterangepicker-material";
import { MatButtonModule } from "@angular/material/button";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatRippleModule } from "@angular/material/core";
import { MatSortModule } from "@angular/material/sort";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { MatTableModule } from "@angular/material/table";
import { MatTabsModule } from "@angular/material/tabs";
import { NgxChartsModule } from "@swimlane/ngx-charts";
import { FuseWidgetModule } from "../../../../../@fuse/components";
import { AgmCoreModule } from "@agm/core";
import { MatSelectModule } from "@angular/material/select";
import { BaseListService } from "../../base/base-list.service";
import { StatusService } from "../status/status.service";
import { MatChipsModule } from "@angular/material/chips";
import { SharedModule } from "../../common/shared.module";
import { AuthGuard } from "../../auth/auth.guard";
import { CaseListComponent } from "./cases-list/case-list.component";
import { CaseDetailComponent } from "./case-detail/case-detail/case-detail.component";
import { CasesService } from "./cases.service";
import { AddCaseDialogComponent } from "./add-case/add-case-dialog.component";
import { EditCaseDialogComponent } from "./edit-case/edit-case-dialog.component";
import { ReminderHistoryComponent } from './reminder/reminder-history/reminder-history.component';
import { ViewReminderComponent } from './reminder/view-reminder/view-reminder.component';
import { ViewReminderDetailsComponent } from './reminder/view-reminder-details/view-reminder-details.component';
import { ReminderHistoryDetailsComponent } from './reminder/reminder-history-details/reminder-history-details.component';
import { DataService } from "./reminder/shared.service";
import { ReminderPopupComponent } from './reminder/reminder-popup/reminder-popup.component';
import { ReminderService } from "./reminder/reminder-popup/reminder-popup.service";
import { ReminderDialogComponent } from "./reminder/reminder-dialog/reminder-dialog.component";

const routes = [
    {
        path: "cases/cases-list",
        component: CaseListComponent,
        canActivate: [AuthGuard],
    },
        {
        path: "cases/casedetails",
        component: CaseDetailComponent,
        canActivate: [AuthGuard],
    },
    {
        path: "cases/reminder-history",
        component: ReminderHistoryComponent,
        canActivate: [AuthGuard],
    },
    // {
    //     path: "cases/view-reminder",
    //     component: ViewReminderComponent,
    //     canActivate: [AuthGuard],
    // },
    // {
    //     path: "cases/view-reminder/details",
    //     component: ViewReminderDetailsComponent,
    //     canActivate: [AuthGuard],
    // },
    {
        path: "cases/reminder-history/details",
        component: ReminderHistoryDetailsComponent,
        canActivate: [AuthGuard],
    }
];

@NgModule({
    declarations: [
        CaseListComponent,
        CaseDetailComponent,
        AddCaseDialogComponent,
        EditCaseDialogComponent,
        ReminderHistoryComponent,
        // ViewReminderComponent,
        ViewReminderDetailsComponent,
        ReminderHistoryDetailsComponent,
        ReminderPopupComponent,
        ReminderDialogComponent
    ],
    imports: [
        RouterModule.forChild(routes),
        TranslateModule,
        FuseSharedModule,
        AsapMaterialModule,
        NgxDaterangepickerMd,
        SharedModule,
        MatTableModule,
        MatButtonModule,
        MatChipsModule,
        MatExpansionModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatPaginatorModule,
        MatRippleModule,
        MatSelectModule,
        MatSortModule,
        MatSnackBarModule,
        MatTabsModule,

        NgxChartsModule,
        AgmCoreModule.forRoot({
            apiKey: "AIzaSyD81ecsCj4yYpcXSLFcYU97PvRsE_X8Bx8",
        }),

        FuseSharedModule,
        FuseWidgetModule,
        // NgxQRCodeModule
        TranslateModule
    ],
    entryComponents: [
        AddCaseDialogComponent,
        EditCaseDialogComponent,
        ReminderDialogComponent
    ],
    exports: [
        CaseListComponent,
        CaseDetailComponent,
        AddCaseDialogComponent,
        EditCaseDialogComponent,
        ReminderHistoryComponent,
        // ViewReminderComponent,
        ViewReminderDetailsComponent,
        ReminderHistoryDetailsComponent,
        ReminderPopupComponent,
        ReminderDialogComponent
    ],
    providers: [
        StatusService,
        CasesService,
        DataService,
        ReminderService,
    ],
})
export class CaseModule {}
